export function upperCaseFirst(str?: string): string {
  if (typeof str === "undefined") return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
